<template>
  <v-container class="container">
    <div class="d-flex align-center gap-4">
      <div>
        <v-img :src="store.Brand?.logo" height="50" width="50" contain />
      </div>
      <component :is="$vuetify.breakpoint.mdAndUp ? 'h2' : 'h3'" class="mb-0">
        {{ store.Condominium.name }}
      </component>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ props, on }">
          <v-btn @click="logs" icon v-bind="props" v-on="on">
            <v-icon>mdi-file-document-outline</v-icon>
          </v-btn>
        </template>
        <span>Registros</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ props, on }">
          <v-btn @click="config" icon v-bind="props" v-on="on">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <span>Configurações</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ props, on }">
          <v-btn to="/app" icon v-bind="props" v-on="on">
            <v-icon>mdi-swap-horizontal</v-icon>
          </v-btn>
        </template>
        <span>Trocar de loja</span>
      </v-tooltip>
    </div>

    <ClientManagement />
    <Settings ref="settings" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ClientManagement from "../store/ClientManagement.vue";
import Settings from "../../components/store/modal/Settings.vue";

export default {
  name: "Home",
  data: () => ({}),
  methods: {
    config() {
      this.$refs.settings.open();
    },
    logs() {
      this.$router.push({
        name: "store.logs",
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },
  computed: {
    ...mapGetters("store", ["storeById"]),
    store() {
      return this.storeById(this.$route.params.id);
    },
  },
  components: { ClientManagement, Settings },
};
</script>

<style lang="scss">
.cover-upload-wrapper {
  display: flex;
  align-items: flex-end;

  .cover-upload {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: auto;
    padding: 0;
  }
  input {
    display: none;
  }
}
</style>
